<div *transloco="let t" class="card smooth-shadow home-item" [hidden]="(auctions.empty$ | async) !== false" [ngClass]="{ empty: auctions.empty$ | async }">
    <h2>{{ t('home.hot-auctions-title') }}</h2>

    <td-hot-auction-summary-table #auctions class="full-card-width" [noShadow]="true"></td-hot-auction-summary-table>
</div>
